module.exports = __webpack_public_path__ + "img/oldman.21069b7c.png";